export const HeaderHeight = 120;

export const MENU_Z_INDEX = 10;
export const HEADER_Z_INDEX = 20;